import { createFileRoute } from '@tanstack/react-router';

import { ReportExplorerPage } from '../features/reporting/reportExplorer/components/ReportExplorerPage';
import { ReportExplorerScope } from '../features/reporting/reportExplorer/reportEnums';
import {
  parseReportExplorerRouteSearch,
  reportExplorerRouteSearchSchema,
} from '../features/reporting/reportExplorer/reportExplorerRouteSearch';
import { useReportShareQuery } from '../features/reporting/reportExplorer/hooks';
import { reportRequestsToExplorerConfiguration } from '../features/reporting/reportExplorer/reportConfiguration';
import { dashboardT } from '../lib/messages';

export const Route = createFileRoute('/p/$publisherId_/reporting/report-explorer')({
  validateSearch: reportExplorerRouteSearchSchema,
  component: PublisherReportExplorerRoute,
});

function PublisherReportExplorerRoute() {
  const { publisherId } = Route.useParams();
  const search = Route.useSearch();
  const sharedReportQuery = useReportShareQuery(search.u);
  const requestedSharedReport = Boolean(search.u);

  if (requestedSharedReport && sharedReportQuery.isLoading) {
    return (
      <PublisherReportExplorerRouteState message={dashboardT('reportExplorer.share.loading')} />
    );
  }
  if (
    requestedSharedReport &&
    (sharedReportQuery.isError ||
      !sharedReportQuery.data ||
      sharedReportQuery.data.publisherId !== publisherId)
  ) {
    return (
      <PublisherReportExplorerRouteState message={dashboardT('reportExplorer.share.openError')} />
    );
  }
  const sharedReport = sharedReportQuery.data;
  return (
    <ReportExplorerPage
      key={sharedReport ? `share-${sharedReport.urlHash}` : 'publisher-report'}
      scope={ReportExplorerScope.Publisher}
      publisherId={publisherId}
      initialConfiguration={
        sharedReport
          ? reportRequestsToExplorerConfiguration(sharedReport.report, sharedReport.chartReports, {
              ...sharedReport.settings,
              resolveRelativeDateRange: true,
            })
          : parseReportExplorerRouteSearch(search)
      }
    />
  );
}

function PublisherReportExplorerRouteState({ message }: { message: string }) {
  return (
    <main className="min-w-0 flex-1 p-4 sm:p-6 lg:p-8">
      <div className="border-border bg-card text-muted-foreground mx-auto w-full max-w-[1920px] rounded-xl border p-8 text-sm">
        {message}
      </div>
    </main>
  );
}
